@if (type(); as type) {
  @if (
    type.name === 'vimeo' ||
    type.name === 'youtube' ||
    type.name === 'google maps' ||
    type.name === 'soundcloud' ||
    type.name === 'facebook' ||
    type.name === 'generic' ||
    type.name === 'kuula' ||
    type.name === 'looker-studio'
  ) {
    <div class="iframe-container {{ type.name }}">
      @if (type.name === 'vimeo') {
        <iframe
          [src]="embedUrl()"
          width="640"
          height="360"
          frameborder="0"
          allow="autoplay; fullscreen; picture-in-picture"
          allowfullscreen
          loading="lazy"
          class="vimeo"
        ></iframe>
      }
      @if (type.name === 'youtube') {
        <iframe
          width="640"
          height="360"
          [src]="embedUrl()"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
          loading="lazy"
          class="youtube"
        ></iframe>
      }
      @if (type.name === 'google maps') {
        <iframe
          [src]="embedUrl()"
          width="640"
          height="360"
          style="border: 0"
          allowfullscreen=""
          loading="lazy"
          class="google-maps"
        ></iframe>
      }
      @if (type.name === 'soundcloud') {
        <iframe
          width="100%"
          height="300"
          scrolling="no"
          frameborder="no"
          allow="autoplay"
          class="soundcloud"
          [src]="embedUrl()"
        ></iframe>
      }
      @if (type.name === 'facebook') {
        <iframe
          [src]="embedUrl()"
          width="500"
          height="500"
          class="facebook"
          style="border: none; overflow: hidden"
          scrolling="no"
          frameborder="0"
          allowfullscreen="true"
          allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share"
        ></iframe>
      }
      @if (type.name === 'kuula') {
        <iframe
          [src]="embedUrl()"
          class="generic"
          style="border: none; overflow: hidden"
          scrolling="no"
          allow="xr-spatial-tracking; gyroscope; accelerometer"
          frameborder="0"
          allowfullscreen
        ></iframe>
      }
      @if (type.name === 'looker-studio') {
        <iframe
          [src]="embedUrl()"
          class="looker-studio"
          style="border: none; overflow: hidden"
          scrolling="no"
          allow="xr-spatial-tracking; gyroscope; accelerometer"
          frameborder="0"
          allowfullscreen
        ></iframe>
      }
      @if (type.name === 'generic') {
        <iframe
          [src]="embedUrl()"
          class="generic"
          style="border: none; overflow: hidden"
          scrolling="no"
          frameborder="0"
          allowfullscreen
        ></iframe>
      }
    </div>
  }
  @if (type.name === 'twitter') {
    <div>
      <blockquote class="twitter-tweet">
        <!--eslint-disable-next-line @angular-eslint/template/elements-content-->
        <a href="https://twitter.com/BBCMOTD/status/{{ embedUrl() }}"></a>
      </blockquote>
    </div>
  }
  @if (type.name === 'instagram') {
    <div>
      <blockquote
        class="instagram-media"
        data-instgrm-captioned
        [attr.data-instgrm-permalink]="embedUrlString()"
        data-instgrm-version="14"
        style="max-width: 540px; min-width: 326px; padding: 0; width: 99.375%; width: calc(100% - 2px)"
      ></blockquote>
    </div>
  }
  @if (type.name === 'elfsight') {
    <div class="elfsight-app-{{ embedUrlString().split('?app=')[1] }}" data-elfsight-app-lazy></div>
  }
}
